var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.253 3.658-2.029-1.532a.624.624 0 0 0-.872.12l-1.065 1.412 3.022 2.283 1.066-1.411a.624.624 0 0 0-.122-.872zM5.375 15.459a2.905 2.905 0 0 0-.467 1.113l-.4 2.683c-.05.34.163.5.475.36l2.472-1.12c.313-.141.736-.48.943-.754l.25-.331-3.023-2.282-.25.33zM9.18 16.706l-3.023-2.282 7.598-10.062 3.022 2.282L9.18 16.706z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEdit);
export default __webpack_public_path__ + "static/media/button-edit.6ac9d6752ce32fafaa8e610dad5948b8.svg";
export { ForwardRef as ReactComponent };